import React, { useState } from 'react';

import { storeConsentMailings } from '../../utils/consentMailings';

function ConsentForm({ alias, onContinue, consentLogoUrl }) {
  const [consentPD, setConsentPD] = useState(false);
  const [consentMailings, setConsentMailings] = useState(false);
  const [showConsentError, setShowConsentError] = useState(false);

  const handleSubmit = event => {
    event.preventDefault();

    // Personal data consent is required; marketing mailings are optional.
    if (!consentPD) {
      setShowConsentError(true);
      return;
    }

    storeConsentMailings(consentMailings);
    onContinue();
  };

  return (
    <div className='form login-form consent-form login-flow'>
      <form className='login-flow__stretch' onSubmit={handleSubmit}>
        <div className='login-flow__above'>
          {consentLogoUrl ? (
            <div className='consent-form__logo-wrap'>
              <img
                className='consent-form__logo'
                src={consentLogoUrl}
                alt=''
                decoding='async'
              />
            </div>
          ) : null}
          <h2 className='consent-form__title text-center mb-2'>
            Оформление карты
          </h2>
          <div className='consent-form__pre-submit'>
            <div
              className={
                showConsentError && !consentPD
                  ? 'consent-form__check-row consent-form__check-row--error'
                  : 'consent-form__check-row'
              }
            >
              <label className='consent-form__check'>
                <input
                  type='checkbox'
                  className='consent-form__check-input'
                  checked={consentPD}
                  onChange={e => {
                    setConsentPD(e.target.checked);
                    setShowConsentError(false);
                  }}
                />
                <span className='consent-form__check-box' aria-hidden='true' />
                <span className='consent-form__check-text'>
                  Я даю согласие на обработку{' '}
                  <a
                    href={`/client/consent/${alias}/personal-data`}
                    target='_blank'
                    rel='noopener noreferrer'
                    onClick={e => e.stopPropagation()}
                  >
                    персональных данных
                  </a>
                </span>
              </label>
            </div>
            <div className='consent-form__check-row'>
              <label className='consent-form__check'>
                <input
                  type='checkbox'
                  className='consent-form__check-input'
                  checked={consentMailings}
                  onChange={e => {
                    setConsentMailings(e.target.checked);
                  }}
                />
                <span className='consent-form__check-box' aria-hidden='true' />
                <span className='consent-form__check-text'>
                  Я даю согласие на получение{' '}
                  <a
                    href={`/client/consent/${alias}/mailings`}
                    target='_blank'
                    rel='noopener noreferrer'
                    onClick={e => e.stopPropagation()}
                  >
                    маркетинговых и информационных рассылок
                  </a>
                </span>
              </label>
            </div>
          </div>
        </div>
        <button
          type='submit'
          className='form__submit-btn consent-form__submit login-flow__submit'
        >
          Далее
        </button>
        <div className='login-flow__below' />
      </form>
    </div>
  );
}

export default ConsentForm;
